import _ from 'lodash';

/**
 * @typedef {object} MetaResponseData
 * @property {number} count
 * @property {string} fullUrl
 * @property {string} fullUrlWithoutSeo
 * @property {string} h1
 * @property {string} mapUrl
 * @property {boolean} redirectToOldForm
 * @property {string} url
 */

export default angular.module('cian.newbuild.filter.metaService', [])
  .factory('MetaService', ['$log', '$q', '$rootScope', 'ApiService', ($log, $q, $rootScope, ApiService) => {
    const service = {};

    const callbacks = {};
    let canceller;
    let metaquery;

    // Utils

    const registerCallback = event => cb => {
      callbacks[event] = callbacks[event] || [];
      callbacks[event].push(cb);
    };

    const callEachCallback = (event, params) => {
      angular.forEach(callbacks[event], cb => cb(params));
    };

    // TODO удалить этот код, после выкатки на все регионы
    window.__redirectToOldForm = false;
    window.__url = '';

    service.isUpdating = () => metaquery && metaquery.$$state.status === 0;

    service.updateMeta = query => {
      if (service.isUpdating()) {
        // Cancel previous query
        canceller.resolve('requesting new meta');
      } else {
        callEachCallback('request');
      }

      canceller = $q.defer();

      // Отбрасываем page, чтобы ссылка для редиректа в ответе была на 1 страницу
      // Аналогично отбрасываем сортировку
      metaquery = ApiService.getQueryMeta(_.omit(query, ['page', 'sort', 'quality']), {
        timeout: canceller.promise,
      }).then(
        data => {
          /**
           * @memberOf MetaService
           * @type {MetaResponseData}
           */
          service.lastMeta = data;
          callEachCallback('receive', data);

          // TODO удалить этот код, после выкатки на все регионы
          window.__redirectToOldForm = data.redirectToOldForm;
          window.__currentFiltersUrl = data.fullUrl;
        }
      );
    };

    service.onRequest = registerCallback('request');
    service.onReceive = registerCallback('receive');

    service.reset = newUrl => {
      service.lastMeta = null;
      callEachCallback('receive', {
        url: newUrl,
      });
    };

    return service;
  }])
  .name;



// WEBPACK FOOTER //
// ./src/serp/services/meta.service.js